export default "__VITE_ASSET__3233c175__"